import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import store from '../../../store/SparePartsFinderTextSearchBasketStore';
import SPFProductSerialNumberCart from './cart/SPFProductSerialNumberCart';
import SparePartsFinderTextSearchIndexPage from '../spare-parts-finder-text-search/SparePartsFinderTextSearchIndexPage';
import SparePartsFinderProductSerialNumberIndexTable from './SparePartsFinderProductSerialNumberIndexTable';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import SparePartsFinderProductSerialNumberApiService
    from '@lib/api-services/SparePartsFinderProductSerialNumberApiService';

const page = observer(
    class SparePartsFinderProductSerialNumberIndexPage extends SparePartsFinderTextSearchIndexPage {
        static defaultProps = {
            tableComponentClass: SparePartsFinderProductSerialNumberIndexTable,
            indexTablePagerVisible: false
        }

        constructor(props) {
            super(props);
        }

        onRowCheckboxToggledPost = () => {
            var request = this.buildIndexAPIRequestModel();
            var service = APIServicesRegistry.getService(SparePartsFinderProductSerialNumberApiService);
            this.setState({
                isLoading: true
            });

            service.getPriceSummary({
                ...request,
                selectedIds: this.getSelectedRowIds()
            }).then(response => {
                this.setState({
                    priceSummary: response.data,
                    isLoading: false
                })
            })
        }

        renderBasket() {
            var market = this.state.filter.viewFilters.find(x => x.meta.slug === 'Market');
            if (!store.basketIsOpen) {
                return (
                    <React.Fragment/>
                )
            }

            return (
                <SPFProductSerialNumberCart market={market.model}/>
            )
        }
    }
)

export default page;